//Elem 0 = ua, 1 = en

export const SECONDARY_RAW_MATERIALS_SCRAP_CATEGORY_MENU_LANG = ['Металобрухт, вторсировина', 'Secondary raw materials, scrap'];

